<!-- Wrapper con scroll -->
<div style="max-height: 65vh; overflow-y: auto; padding-right: 0.25rem;">

<!-- PASO 1: Ingresar Username -->
<div *ngIf="step === 'username'">
  <div class="form-header" style="margin-bottom: 1.5rem;">
    <h3 class="form-title" style="font-size: 1.5rem; margin-bottom: 0.5rem;">Recuperar Contraseña</h3>
    <p class="form-subtitle" style="font-size: 0.9375rem;">Ingresa tu nombre de usuario</p>
  </div>

  <!-- Error Messages -->
  <div *ngIf="errors && errors.length > 0" class="error-container" style="margin-bottom: 1.5rem;">
    <div class="error-alert" *ngFor="let error of errors" style="background: #fef2f2; border: 1px solid #fecaca; border-radius: 8px; padding: 1rem; display: flex; gap: 0.625rem; align-items: start;">
      <i class="fas fa-exclamation-triangle" style="color: #dc2626; margin-top: 0.125rem;"></i>
      <span style="color: #991b1b; font-size: 0.875rem;">{{ error.msg }}</span>
    </div>
  </div>

  <form (ngSubmit)="submitUsername()">
    <!-- Username Field -->
    <div class="input-group" style="margin-bottom: 1.5rem;">
      <label for="username" class="input-label" style="font-size: 0.9375rem; margin-bottom: 0.625rem; display: block; font-weight: 600; color: #374151;">Usuario</label>
      <input 
        type="text" 
        id="username" 
        [(ngModel)]="username"
        name="username"
        placeholder="Ingresa tu usuario"
        required
        minlength="3"
        style="width: 100%; padding: 0.875rem 1rem; border: 2px solid #e5e7eb; border-radius: 8px; font-size: 0.9375rem; transition: all 0.2s;">
    </div>

    <!-- Buttons -->
    <div style="display: flex; gap: 0.75rem;">
      <button type="button" (click)="cancel()" [disabled]="loading" style="flex: 1; background: white; border: 2px solid #e5e7eb; border-radius: 8px; padding: 0.875rem 1.5rem; color: #6b7280; font-size: 0.9375rem; font-weight: 600; cursor: pointer; transition: all 0.2s;" onmouseover="if(!this.disabled) { this.style.borderColor='#9ca3af'; this.style.color='#374151'; }" onmouseout="if(!this.disabled) { this.style.borderColor='#e5e7eb'; this.style.color='#6b7280'; }">
        <i class="fas fa-arrow-left" style="margin-right: 0.5rem;"></i>
        Cancelar
      </button>
      <button type="submit" [disabled]="!username || username.length < 3 || loading" style="flex: 1; background: #01abce; border: 2px solid #01abce; border-radius: 8px; padding: 0.875rem 1.5rem; color: white; font-size: 0.9375rem; font-weight: 600; cursor: pointer; transition: all 0.2s;" [style.opacity]="!username || username.length < 3 || loading ? '0.5' : '1'" [style.cursor]="!username || username.length < 3 || loading ? 'not-allowed' : 'pointer'" onmouseover="if(!this.disabled) { this.style.background='#0194b3'; this.style.borderColor='#0194b3'; }" onmouseout="if(!this.disabled) { this.style.background='#01abce'; this.style.borderColor='#01abce'; }">
        <i class="fas" [class.fa-arrow-right]="!loading" [class.fa-spinner]="loading" [class.fa-spin]="loading" style="margin-right: 0.5rem;"></i>
        {{ loading ? 'Procesando...' : 'Continuar' }}
      </button>
    </div>
  </form>
</div>

<!-- PASO 2: Selector de Método 2FA (Componente Reutilizado) -->
<app-select-2fa-method
  *ngIf="step === 'select-method'"
  [tempToken]="tempToken"
  [availableMethods]="availableMethods"
  [configuredMethods]="configuredMethods"
  [phoneNumber]="phoneNumber"
  (onMethodSelected)="onMethodSelected($event)"
  (onCancel)="cancel()">
</app-select-2fa-method>

<!-- PASO 3: Verificar Código 2FA -->
<div *ngIf="step === 'verify-code'">
  <div class="form-header" style="margin-bottom: 1.5rem;">
    <h3 class="form-title" style="font-size: 1.5rem; margin-bottom: 0.5rem;">Verificar Código</h3>
    <p class="form-subtitle" style="font-size: 0.9375rem;">
      {{ selectedMethod === 'sms' ? 'Ingresa el código enviado a ' + phoneNumber : 'Ingresa el código de Google Authenticator' }}
    </p>
  </div>

  <!-- Error Messages -->
  <div *ngIf="errors && errors.length > 0" class="error-container" style="margin-bottom: 1.5rem;">
    <div class="error-alert" *ngFor="let error of errors" style="background: #fef2f2; border: 1px solid #fecaca; border-radius: 8px; padding: 1rem; display: flex; gap: 0.625rem; align-items: start;">
      <i class="fas fa-exclamation-triangle" style="color: #dc2626; margin-top: 0.125rem;"></i>
      <span style="color: #991b1b; font-size: 0.875rem;">{{ error.msg }}</span>
    </div>
  </div>

  <form (ngSubmit)="verifyCodeAndContinue()">
    <!-- Verification Code Field -->
    <div class="input-group" style="margin-bottom: 1.5rem;">
      <label for="verificationCode" class="input-label" style="font-size: 0.9375rem; margin-bottom: 0.625rem; display: block; font-weight: 600; color: #374151;">Código de Verificación</label>
      <input 
        type="text" 
        id="verificationCode" 
        [(ngModel)]="verificationCode"
        name="verificationCode"
        placeholder="000000"
        required
        maxlength="6"
        pattern="[0-9]{6}"
        style="width: 100%; padding: 0.875rem 1rem; border: 2px solid #e5e7eb; border-radius: 8px; font-size: 0.9375rem; text-align: center; letter-spacing: 0.5rem; font-weight: 600; transition: all 0.2s;">
    </div>

    <!-- Buttons -->
    <div style="display: flex; gap: 0.75rem;">
      <button type="button" (click)="step = 'select-method'" [disabled]="loading" style="flex: 1; background: white; border: 2px solid #e5e7eb; border-radius: 8px; padding: 0.875rem 1.5rem; color: #6b7280; font-size: 0.9375rem; font-weight: 600; cursor: pointer; transition: all 0.2s;" onmouseover="if(!this.disabled) { this.style.borderColor='#9ca3af'; this.style.color='#374151'; }" onmouseout="if(!this.disabled) { this.style.borderColor='#e5e7eb'; this.style.color='#6b7280'; }">
        <i class="fas fa-arrow-left" style="margin-right: 0.5rem;"></i>
        Atrás
      </button>
      <button type="submit" [disabled]="!verificationCode || verificationCode.length !== 6 || loading" style="flex: 1; background: #01abce; border: 2px solid #01abce; border-radius: 8px; padding: 0.875rem 1.5rem; color: white; font-size: 0.9375rem; font-weight: 600; cursor: pointer; transition: all 0.2s;" [style.opacity]="!verificationCode || verificationCode.length !== 6 || loading ? '0.5' : '1'" [style.cursor]="!verificationCode || verificationCode.length !== 6 || loading ? 'not-allowed' : 'pointer'" onmouseover="if(!this.disabled) { this.style.background='#0194b3'; this.style.borderColor='#0194b3'; }" onmouseout="if(!this.disabled) { this.style.background='#01abce'; this.style.borderColor='#01abce'; }">
        <i class="fas" [class.fa-check]="!loading" [class.fa-spinner]="loading" [class.fa-spin]="loading" style="margin-right: 0.5rem;"></i>
        {{ loading ? 'Verificando...' : 'Continuar' }}
      </button>
    </div>
  </form>
</div>

<!-- PASO 4: Nueva Contraseña -->
<div *ngIf="step === 'new-password'">
  <div class="form-header" style="margin-bottom: 1.5rem;">
    <h3 class="form-title" style="font-size: 1.5rem; margin-bottom: 0.5rem;">Nueva Contraseña</h3>
    <p class="form-subtitle" style="font-size: 0.9375rem;">Crea una contraseña segura</p>
  </div>

  <!-- Error Messages -->
  <div *ngIf="errors && errors.length > 0" class="error-container" style="margin-bottom: 1.5rem;">
    <div class="error-alert" *ngFor="let error of errors" style="background: #fef2f2; border: 1px solid #fecaca; border-radius: 8px; padding: 1rem; display: flex; gap: 0.625rem; align-items: start;">
      <i class="fas fa-exclamation-triangle" style="color: #dc2626; margin-top: 0.125rem;"></i>
      <span style="color: #991b1b; font-size: 0.875rem;">{{ error.msg }}</span>
    </div>
  </div>

  <form (ngSubmit)="submitNewPassword()">
    <!-- Nueva Contraseña -->
    <div class="input-group" style="margin-bottom: 1rem;">
      <label for="newPassword" class="input-label" style="font-size: 0.9375rem; margin-bottom: 0.625rem; display: block; font-weight: 600; color: #374151;">Nueva Contraseña</label>
      <div style="position: relative;">
        <input 
          [type]="showNewPassword ? 'text' : 'password'" 
          id="newPassword" 
          #newPasswordInput
          (input)="newPassword = newPasswordInput.value"
          [value]="newPassword"
          placeholder="Ingresa tu nueva contraseña"
          style="width: 100%; padding: 0.875rem 3rem 0.875rem 1rem; border: 2px solid #e5e7eb; border-radius: 8px; font-size: 0.9375rem; transition: all 0.2s;">
        <button 
          type="button" 
          (click)="toggleNewPasswordVisibility()" 
          style="position: absolute; right: 1rem; top: 50%; transform: translateY(-50%); background: none; border: none; cursor: pointer; color: #6b7280; padding: 0; display: flex; align-items: center; justify-content: center;">
          <i class="fas" [class.fa-eye]="!showNewPassword" [class.fa-eye-slash]="showNewPassword" style="font-size: 1.125rem;"></i>
        </button>
      </div>
    </div>

    <!-- Confirmar Contraseña -->
    <div class="input-group" style="margin-bottom: 1rem;">
      <label for="confirmPassword" class="input-label" style="font-size: 0.9375rem; margin-bottom: 0.625rem; display: block; font-weight: 600; color: #374151;">Confirmar Contraseña</label>
      <div style="position: relative;">
        <input 
          [type]="showConfirmPassword ? 'text' : 'password'" 
          id="confirmPassword" 
          #confirmPasswordInput
          (input)="confirmPassword = confirmPasswordInput.value"
          [value]="confirmPassword"
          placeholder="Confirma tu nueva contraseña"
          style="width: 100%; padding: 0.875rem 3rem 0.875rem 1rem; border: 2px solid #e5e7eb; border-radius: 8px; font-size: 0.9375rem; transition: all 0.2s;">
        <button 
          type="button" 
          (click)="toggleConfirmPasswordVisibility()" 
          style="position: absolute; right: 1rem; top: 50%; transform: translateY(-50%); background: none; border: none; cursor: pointer; color: #6b7280; padding: 0; display: flex; align-items: center; justify-content: center;">
          <i class="fas" [class.fa-eye]="!showConfirmPassword" [class.fa-eye-slash]="showConfirmPassword" style="font-size: 1.125rem;"></i>
        </button>
      </div>
    </div>

    <!-- Requisitos de Contraseña -->
    <div style="background: #f9fafb; border: 1px solid #e5e7eb; border-radius: 8px; padding: 1rem; margin-bottom: 1.5rem;">
      <p style="font-size: 0.875rem; font-weight: 600; color: #374151; margin: 0 0 0.75rem 0;">Requisitos de contraseña:</p>
      <div style="display: flex; flex-direction: column; gap: 0.5rem;">
        <div style="display: flex; align-items: center; gap: 0.5rem;">
          <i class="fas" [class.fa-check-circle]="passwordHasMinLength && passwordHasMaxLength" [class.fa-circle]="!passwordHasMinLength || !passwordHasMaxLength" [style.color]="passwordHasMinLength && passwordHasMaxLength ? '#10b981' : '#9ca3af'" style="font-size: 0.875rem;"></i>
          <span style="font-size: 0.875rem; color: #6b7280;">Entre 6 y 12 caracteres</span>
        </div>
        <div style="display: flex; align-items: center; gap: 0.5rem;">
          <i class="fas" [class.fa-check-circle]="passwordHasLowercase" [class.fa-circle]="!passwordHasLowercase" [style.color]="passwordHasLowercase ? '#10b981' : '#9ca3af'" style="font-size: 0.875rem;"></i>
          <span style="font-size: 0.875rem; color: #6b7280;">Al menos una minúscula</span>
        </div>
        <div style="display: flex; align-items: center; gap: 0.5rem;">
          <i class="fas" [class.fa-check-circle]="passwordHasUppercase" [class.fa-circle]="!passwordHasUppercase" [style.color]="passwordHasUppercase ? '#10b981' : '#9ca3af'" style="font-size: 0.875rem;"></i>
          <span style="font-size: 0.875rem; color: #6b7280;">Al menos una mayúscula</span>
        </div>
        <div style="display: flex; align-items: center; gap: 0.5rem;">
          <i class="fas" [class.fa-check-circle]="passwordHasNumber" [class.fa-circle]="!passwordHasNumber" [style.color]="passwordHasNumber ? '#10b981' : '#9ca3af'" style="font-size: 0.875rem;"></i>
          <span style="font-size: 0.875rem; color: #6b7280;">Al menos un número</span>
        </div>
        <div style="display: flex; align-items: center; gap: 0.5rem;">
          <i class="fas" [class.fa-check-circle]="passwordHasSpecialChar" [class.fa-circle]="!passwordHasSpecialChar" [style.color]="passwordHasSpecialChar ? '#10b981' : '#9ca3af'" style="font-size: 0.875rem;"></i>
          <span style="font-size: 0.875rem; color: #6b7280;">Al menos un carácter especial (@$!%*?&.#-_,;:+etc.)</span>
        </div>
        <div style="display: flex; align-items: center; gap: 0.5rem;">
          <i class="fas" [class.fa-check-circle]="passwordsMatch" [class.fa-circle]="!passwordsMatch" [style.color]="passwordsMatch ? '#10b981' : '#9ca3af'" style="font-size: 0.875rem;"></i>
          <span style="font-size: 0.875rem; color: #6b7280;">Las contraseñas coinciden</span>
        </div>
      </div>
    </div>

    <!-- Buttons -->
    <button type="submit" [disabled]="!isPasswordValid() || loading" style="width: 100%; background: #01abce; border: 2px solid #01abce; border-radius: 8px; padding: 0.875rem 1.5rem; color: white; font-size: 0.9375rem; font-weight: 600; cursor: pointer; transition: all 0.2s;" [style.opacity]="!isPasswordValid() || loading ? '0.5' : '1'" [style.cursor]="!isPasswordValid() || loading ? 'not-allowed' : 'pointer'" onmouseover="if(!this.disabled) { this.style.background='#0194b3'; this.style.borderColor='#0194b3'; }" onmouseout="if(!this.disabled) { this.style.background='#01abce'; this.style.borderColor='#01abce'; }">
      <i class="fas" [class.fa-check]="!loading" [class.fa-spinner]="loading" [class.fa-spin]="loading" style="margin-right: 0.5rem;"></i>
      {{ loading ? 'Cambiando contraseña...' : 'Cambiar Contraseña' }}
    </button>
  </form>
</div>

</div>
